module.exports = __webpack_public_path__ + "img/第1章_2-1_賴和面具.png";